import { fromJS, Record } from 'immutable';

export const paymentMethodsRecord = new Record({
  byId: fromJS({}),
  allIds: fromJS([]),
  byProjectId: fromJS({})
});

export default paymentMethodsRecord();
